/* ODD MUSE — Bridal Landing interactions
   Scoped to run once per section instance on the page. */
(function () {
  document.querySelectorAll('.bridal').forEach(function (root) {
    if (root.dataset.bridalInit) return;
    root.dataset.bridalInit = 'true';

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var inThemeEditor = window.Shopify && window.Shopify.designMode;

    // Threshold
    var threshold = root.querySelector('[data-threshold]');
    var thresholdWord = root.querySelector('[data-threshold-word]');
    if (threshold) {
      if (inThemeEditor || prefersReduced) {
        threshold.classList.add('is-hidden');
      } else {
        requestAnimationFrame(function () {
          setTimeout(function () {
            if (thresholdWord) thresholdWord.classList.add('is-visible');
          }, 150);
        });
        setTimeout(function () { threshold.classList.add('is-hidden'); }, 2200);
      }
    }

    // Hero word-by-word reveal
    var heroSpans = root.querySelectorAll('[data-hero-title] span');
    var heroScroll = root.querySelector('[data-hero-scroll]');

    if (inThemeEditor) {
      heroSpans.forEach(function (el) { el.classList.add('is-in'); });
      if (heroScroll) heroScroll.classList.add('is-in');
    } else {
      var revealDelay = (threshold && !prefersReduced) ? 2400 : 200;
      setTimeout(function () {
        heroSpans.forEach(function (el, i) {
          setTimeout(function () { el.classList.add('is-in'); }, i * 260);
        });
        if (heroScroll) heroScroll.classList.add('is-in');
      }, revealDelay);
    }

    // Scroll reveals
    var revealEls = root.querySelectorAll('.bridal-reveal');
    if (inThemeEditor) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-in');
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    }

    // Subtle hero parallax
    if (!prefersReduced && !inThemeEditor) {
      var bg = root.querySelector('[data-parallax]');
      window.addEventListener('scroll', function () {
        if (!bg) return;
        var y = window.scrollY;
        bg.style.transform = 'translateY(' + (y * 0.08) + 'px) scale(1.04)';
      }, { passive: true });
    }

    // Notify me sign-up (Klaviyo)
    var notifyForms = root.querySelectorAll('[data-notify-form]');
    notifyForms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var input = form.querySelector('[data-notify-input]');
        var nameInput = form.querySelector('[data-notify-name]');
        var dateInput = form.querySelector('[data-notify-date]');
        var msg = form.querySelector('[data-notify-message]');
        var submitBtn = form.querySelector('[data-notify-submit]');
        var label = form.querySelector('[data-notify-submit-label]');

        var email = (input.value || '').trim();
        var name = nameInput ? (nameInput.value || '').trim() : '';
        var weddingDate = dateInput ? (dateInput.value || '').trim() : '';

        msg.classList.remove('is-error');

        if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
          msg.textContent = 'Please enter a valid email address.';
          msg.classList.add('is-error');
          return;
        }

        var companyId = form.dataset.klaviyoCompany;
        var listId = form.dataset.klaviyoList;

        if (!companyId || !listId) {
          msg.textContent = 'Sign-up is not configured yet.';
          msg.classList.add('is-error');
          return;
        }

        submitBtn.disabled = true;
        if (label) label.textContent = 'Submitting…';

        var profileAttributes = { email: email };
        if (name) profileAttributes.first_name = name;
        if (weddingDate) {
          profileAttributes.properties = { wedding_date: weddingDate };
        }

        fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + companyId, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: profileAttributes
                  }
                }
              },
              relationships: {
                list: { data: { type: 'list', id: listId } }
              }
            }
          })
        })
          .then(function (res) {
            if (res.ok || res.status === 202) {
              form.reset();
              msg.textContent = form.dataset.successMessage || "You're on the list — we'll be in touch.";
              if (label) label.textContent = 'Signed Up';
            } else {
              throw new Error('Klaviyo request failed');
            }
          })
          .catch(function () {
            msg.textContent = form.dataset.errorMessage || 'Something went wrong. Please try again.';
            msg.classList.add('is-error');
            submitBtn.disabled = false;
            if (label) label.textContent = form.dataset.buttonLabel || 'Notify Me';
          });
      });
    });
  });
})();